import React, { useEffect } from "react";
import "./Shibir_Registration.css";
import Breadcrumb_Comp from "../common/common_components/breadcrumb_comp/Breadcrumb_Comp";
import Steps_Banner from "./steps_banner/Steps_Banner";
import Practise_List_Component from "./practise_list_component/Practise_List_Component";
import { EventPrograms, SingleEvent } from "../../features/admin/common/Slice";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { decodeId } from "../../utils/common";

const Shibir_Registration = () => {

  const id = useParams()

  const dispatch = useDispatch();

  const event = useSelector((state) => state.common.event);
  const eventPrograms = useSelector((state) => state.common.all_event_programs);


  useEffect(() => {
    if (id) {
      dispatch(SingleEvent({ id: decodeId(id.id) }));
      dispatch(EventPrograms({ id: decodeId(id.id) }));
    }
  }, [dispatch]);
  const breadcrumbs = [
    { label: "EXPLORE", link: "/explore", active: false },
    {
      label: "SHIBIR & EVENT REGISTRATIONS",
      link: "/event-registration",
      active: false,
    },
    { label: event?.name, link: "", active: false },
  ];
  return (
    <section className="Shibir_Registration">
      <div className="container">
        <Breadcrumb_Comp data={breadcrumbs} />
        <Steps_Banner event={event} />
        <Practise_List_Component eventPrograms={eventPrograms} event={event} />
      </div>
    </section>
  );
};

export default Shibir_Registration;
